import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRteComponent } from './simple-icons-rte.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRteComponent ],
    exports:      [ SimpleIconsRteComponent ],
    bootstrap:    []
})
export class SimpleIconsRteModule {}
